@if(entity.entityType === 'CONTACT') {
    <div class="agpr-entityListItem">
        <div class="agpr-entityListItem-thumbnail">
            <img
                class="agpr-entityListItem-thumbnail-img"
                [agprImageSrc]="entity.avatarUrl"
                [alt]="'Common.journodexQuickSearch.contactProfile.altText' | localize"
                [agprDefaultImage]="imageDefault[entity.entityType]"
                width="30"
                height="30"
            />
        </div>
        @if(entity.entityName) {
            <span class="agpr-entityListItem-name">
                {{ entity.entityName }}
            </span>
        }

        @if(entity.name) {
            <span class="agpr-entityListItem-name">
                {{ entity.name }}
            </span>
        }

        @if(entity.outlet) {
            <span class="agpr-entityListItem-subheading">
                ({{ entity.outlet }})
            </span>
        }
    </div>
}

@if(entity.entityType === 'OUTLET') {
    <div class="agpr-entityListItem">
        <div class="agpr-entityListItem-thumbnail">
            <img
                class="agpr-entityListItem-thumbnail-img"
                [agprImageSrc]="entity.avatarUrl"
                [alt]="'Common.journodexQuickSearch.outletProfile.altText' | localize"
                [agprDefaultImage]="imageDefault[entity.entityType]"
                width="25"
                height="25"
            />
        </div>
        @if(entity.entityName) {
            <span class="agpr-entityListItem-name">
                {{ entity.entityName }}
            </span>
        }

        @if(entity.name) {
            <span class="agpr-entityListItem-name">
                {{ entity.name }}
            </span>
        }

        @if(entity.location) {
            <span class="agpr-entityListItem-subheading">
                ({{ entity.location }})
            </span>
        }
    </div>
}
